import React, { Component } from 'react';
import "./FAQList.css";
import { QAGroups } from "./QAGroups";
import { Toast } from "../ToastAlert/Toast";
export class FAQList extends Component{
state={
  faqs: null,
  title: "That wasn't supposed to happen!",
  description: "We're sorry, something went wrong. Please refresh and try again.",
  alertType: "info"
};
componentWillMount() {
  this.setState({ faqs: [...this.props.faqs] });
}

render() {
  const faqs=this.state.faqs;
  const faqsLength = faqs.length > 0;
  const QAGroupsTemplate=faqs.map((faq, index)=>{
    return(<QAGroups key={`qagroups-${index}`} faq={faq} />);
  });
  return(
    <div className=" white-background justify-content-md-center top-5">
      <div>
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-lg-12 col-sm-12 col-md-12">
              <div className="accordion faq-list">
                <h3 className="header-font standard-blue faq-title text-center">Barclays Personal Loan FAQs</h3>
                { faqsLength ? <div>{ QAGroupsTemplate }</div>
                  : <Toast title={this.state.title} description={this.state.description} alertType={this.state.alertType}/> }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
}
